<template>
  <v-form>
    <!-- Mensaje informativo para observar la web de ejemplo  -->
    <div class="container_info_azul">
      <span>
        {{ $t("Esta herramienta va a permitirte enviar de forma automática un SMS o EMAIL a los clientes en LISTA DE ESPERA cuando quede un hueco disponible en la agenda. Optimiza tu agenda con Last Booking, un sistema que te ayuda a cubrir las cancelaciones de última hora y aprovechar al máximo los huecos libres.") }}
      </span>
    </div>
    <!-- Filtro -->
    <v-row>
      <v-col cols="12" sm="4" md="4" class="pt-3 pb-0">
        <v-switch v-model="config_last_bookingooking.is_notificaciones_lista_espera_email" :label="$t('Notificaciones de lista de espera por email')"
                  class="caption"></v-switch>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="pt-3 pb-0">
        <v-switch v-model="config_last_bookingooking.is_notificaciones_lista_espera_sms" :label="$t('Notificaciones de lista de espera por SMS')"></v-switch>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn class="primary" small block @click="save">
          <v-icon left small>mdi-content-save</v-icon>
          <span>{{ $t("Guardar") }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  name: 'FormLastBooking',
  data: () => ({
    config_last_bookingooking: {},
  }),
  methods: {
    async get_config_last_bookingooking(){
      try{
        this.config_last_bookingooking = await this.$store.dispatch('lastbooking/get_config_last_booking')
      }catch (err){}
    },

    async save(){
      try {
        this.config_last_bookingooking = await this.$store.dispatch('lastbooking/save', this.config_last_bookingooking)
        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    }
  },

  mounted() {
    this.get_config_last_bookingooking()
  },
}
</script>
